export interface GuestInfo {
    name: string;
    message: string;
    multiplePersons: boolean;
}

export const guests: Record<string, GuestInfo> = {
    'gena-vika': {
        name: 'Дорогие Геннадий и Виктория!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: true,
    },
    'shabarchins': {
        name: 'Дорогие Александр, Татьяна и Маргарита!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: true,
    },
    'travkins': {
        name: 'Дорогие Наталья и Анатолий!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: true,
    },
    'viktor': {
        name: 'Дорогой Виктор!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'titovs': {
        name: 'Дорогие Арина и Иван!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: true,
    },
    'vera': {
        name: 'Дорогая Вера Андреевна!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: false,
    },
    'stepans': {
        name: 'Дорогие Наталья Валерьевна и Антон Владимирович!',
        message: 'Вы — часть нашей семьи, и мы будем счастливы видеть вас в этот особенный день.',
        multiplePersons: true,
    },
    'nastya': {
        name: 'Дорогая Анастасия!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'denis': {
        name: 'Дорогой Денис!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'lena': {
        name: 'Дорогая Елена!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'nikita': {
        name: 'Дорогой Никита!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'sveta-ilya': {
        name: 'Дорогие Светлана и Илья!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'kivins': {
        name: 'Дорогие Владимир и Елена!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'sudorgs': {
        name: 'Дорогие Ксения и Максим!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'varya-nikita': {
        name: 'Дорогие Варвара и Никита!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'anya-zhenya': {
        name: 'Дорогие Аня и Женя!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'olya-maksim': {
        name: 'Дорогие Ольга и Максим!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'yana': {
        name: 'Дорогая Яна!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'ruslan': {
        name: 'Дорогой Руслан!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'irina-michael': {
        name: 'Дорогие Ирина и Михаил!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
    'olesya': {
        name: 'Дорогая Олеся!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'boris': {
        name: 'Дорогой Борис!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'sofia': {
        name: 'Дорогая София!',
        message: 'Мы с нетерпением ждём тебя на нашем торжестве.',
        multiplePersons: false,
    },
    'vika-dima': {
        name: 'Дорогие Виктория и Дмитрий!',
        message: 'Мы с нетерпением ждём вас на нашем торжестве.',
        multiplePersons: true,
    },
};

export const defaultGuest: GuestInfo = {
    name: '',
    message: 'Мы рады пригласить вас на наш праздник!',
    multiplePersons: true
};

export function getGuestByInvitationId(invitationId: string | undefined): GuestInfo {
    if (!invitationId) return defaultGuest;
    return guests[invitationId] ?? defaultGuest;
}

